<template>
  <div class="idtr-block idtr-perjury">
    <div class="idtr-perjury__title">{{ text.perjuryTitle }}</div>
    <div class="idtr-perjury__text">{{ text.perjuryText }}</div>
    <div class="idtr-sign">
      <div class="idtr-sign__col idtr-sign__col--name">
        <div class="idtr-sign__top">{{ fullName }}</div>
        <div class="idtr-sign__bottom">{{ fullName }}</div>
      </div>
      <div class="idtr-sign__col idtr-sign__col--date">
        <div class="idtr-sign__top">
          <field-input
            v-model="idtrForm.signatureDate"
            name="Signature date"
            :rules="dateRules"
            bold
            date-format="M/D/YYYY"
          />
        </div>
        <div class="idtr-sign__bottom">{{ text.dateLabel }}</div>
      </div>
    </div>
    <div class="idtr-note">{{ text.note }}</div>
  </div>
</template>

<script>
import FieldInput from "../FieldInput.vue";
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  components: {FieldInput},
  inject: ["idtrForm"],
  data: () => ({
    text: IDTR_TEXT,
    // M/D/YYYY without leading zeros, as printed in the original report (9/15/2026)
    dateRules: {required: true, regex: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/\d{4}$/},
  }),
  computed: {
    fullName() {
      const {firstName, lastName} = this.idtrForm.contact;
      return `${firstName} ${lastName}`.trim();
    },
  },
};
</script>
